import * as types from "./action-types";

import DashboardApi from "../../../api/DashboardApi";

export const fetchProfile = (params, id, type) => ({
	type: types.DASHBOARD_PROFILE,
	payload: DashboardApi.fetchProfile(params, id, type)
});

export const fetchReportDetail = params => ({
	type: types.FETCH_REPORT_DETAILS,
	payload: DashboardApi.getReportDetails(params)
});

export const fetchCardDetails = params => ({
	type: types.FETCH_CARD_DETAILS,
	payload: DashboardApi.getCardDetails(params)
});

export const setCountryConstCenterInsights = filters => ({
	type: types.SET_INSIGHTS_COUNTRY_COSTCENTER,
	data: filters
});

export const setSidePanel = sidePanelObj => ({
	type: types.SET_SIDE_PANEL,
	data: { ...sidePanelObj }
});

export const setBookmark = (id, bookmarked, dashboardType) => ({
	type: types.SET_BOOKMARK,
	payload: DashboardApi.bookmark(id, bookmarked, dashboardType),
	meta: { bookmarked }
});

export const fetchProfileNotes = (params, id, type) => ({
	type: types.PROFILE_NOTES,
	payload: DashboardApi.fetchProfileNotes(params, id, type)
});

export const addCustomNotes = (
	id,
	notes,
	UserFirstName,
	UserSurname,
	dashboardType
) => ({
	type: types.ADD_NOTES,
	payload: DashboardApi.addNotes(id, notes, dashboardType),
	meta: { notes, UserFirstName, UserSurname }
});

export const setVehicleHistoryDetails = leaseData => ({
	type: types.SET_VEHICLE_HISTORY,
	data: leaseData
});

export const fetchVehicleHistoryDetails = leaseId => ({
	type: types.FETCH_VEHICLE_HISTORY,
	payload: DashboardApi.getVehicleHistoryDetails(leaseId)
});



// WEBPACK FOOTER //
// ./src/features/dashboard/actions/index.js